import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import HighchartsVue from 'highcharts-vue';
import browserDetect from "vue-browser-detect-plugin";
import Highcharts from 'highcharts';
import loadWordcloud from 'highcharts/modules/wordcloud';
import highchartsMore from 'highcharts/highcharts-more';

highchartsMore(Highcharts)
loadWordcloud(Highcharts);

Vue.config.productionTip = false;
Vue.use(browserDetect);
Vue.use(HighchartsVue);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



